// extracted by mini-css-extract-plugin
export default {"wrapper":"AssistantInformationTab_wrapper__ZdPac"};